import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'underscore';
import { createHashHistory } from 'history';
import { Container, Row, Col } from 'reactstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { v4 as uuidV4 } from 'uuid';
import entityComposition from '../../common/classes/entityComposition';
import { editPermissionSelector, viewPermissionSelector } from '../../common/classes/permissions';
import JobOpenClosedFilter from './jobOpenClosedFilter';
import JobOrganizationFilter from './jobOrganizationFilter';
import routeHelper from '../../common/classes/routeHelper';
import ListPanel from '../../common/containers/listPanel';
import JobsRow from './jobsRow';
import JobsPagingTable from './jobsPagingTable';
import FormsFilterPanel from '../../forms/formsFilterPanel';
const hashHistory = createHashHistory();
const handleJobSelect = (id, formID) => {
  hashHistory.push("/admin/jobs/".concat(id, "/").concat(formID));
};
const Jobs = _ref => {
  let canView = _ref.canView,
    canEdit = _ref.canEdit,
    country = _ref.country,
    countryActions = _ref.countryActions,
    _ref$currentFormType = _ref.currentFormType,
    currentFormType = _ref$currentFormType === void 0 ? {
      id: 'jobs'
    } : _ref$currentFormType,
    formActions = _ref.formActions,
    formType = _ref.formType,
    formTypeActions = _ref.formTypeActions,
    job = _ref.job,
    jobActions = _ref.jobActions,
    formForm = _ref.formForm,
    formFormActions = _ref.formFormActions,
    location = _ref.location,
    login = _ref.login,
    notificationActions = _ref.notificationActions,
    organizationFilterJob = _ref.organizationFilterJob,
    organizationFilterJobActions = _ref.organizationFilterJobActions,
    _ref$settings = _ref.settings,
    loadingSettings = _ref$settings.loading,
    _ref$settings$setting = _ref$settings.settings,
    _ref$settings$setting2 = _ref$settings$setting === void 0 ? {} : _ref$settings$setting,
    _ref$settings$setting3 = _ref$settings$setting2.cabinets,
    _ref$settings$setting4 = _ref$settings$setting3 === void 0 ? {} : _ref$settings$setting3,
    _ref$settings$setting5 = _ref$settings$setting4.job,
    _ref$settings$setting6 = _ref$settings$setting5 === void 0 ? {} : _ref$settings$setting5,
    _ref$settings$setting7 = _ref$settings$setting6.filters,
    jobFormFilters = _ref$settings$setting7 === void 0 ? [] : _ref$settings$setting7,
    state = _ref.state,
    stateActions = _ref.stateActions;
  useEffect(() => {
    // Redirect and post authorization error message if permissions insufficient
    // Unfortunately early return from this conditional is not allowed due to the rules
    // of hooks: https://legacy.reactjs.org/docs/hooks-rules.html. This forces additional
    // canView checks within useEffect below.
    routeHelper.handleViewRedirect(canView, location);
  }, [canView, location]);
  useEffect(() => {
    // handleViewRedirect will take care of navigation, but further data loading should also be
    // blocked. Potentially revisit when react-router is upgraded with https://www.pivotaltracker.com/story/show/180196587
    if (canView) {
      countryActions.serverIndex(country.indexQuery);
      jobActions.serverIndex(job.indexQuery);
      organizationFilterJobActions.serverIndex(organizationFilterJob.indexQuery);
      stateActions.serverIndex(state.indexQuery);
      formFormActions.serverIndex(formForm.indexQuery);
      formTypeActions.serverIndex(formType.indexQuery);
    }
  }, [canView, countryActions, country.indexQuery, formTypeActions, formType.indexQuery, formFormActions, formForm.indexQuery, jobActions, job.indexQuery, organizationFilterJobActions, organizationFilterJob.indexQuery, stateActions, state.indexQuery]);
  const filterChange = (prop, value) => {
    const newFilters = _objectSpread(_objectSpread({}, job.indexQuery.filters), {}, {
      [prop]: value
    });
    jobActions.serverFilter(newFilters, job.indexQuery);
  };
  const handleAddJob = () => {
    if (!currentFormType) {
      return notificationActions.error({
        message: 'The system is misconfigured: formType.list is missing'
      });
    }
    const jobID = uuidV4().toUpperCase();
    const contractReqID = uuidV4().toUpperCase();
    const createdDate = moment().utc().format('YYYY-MM-DD HH:mm:ss');

    // handle the related jb form
    const formID = uuidV4().toUpperCase();
    formActions.create(formID, createdDate, login.user.user_id, currentFormType);
    jobActions.create(jobID, contractReqID, createdDate, login.user.user_id, formID);
    return handleJobSelect(jobID, formID);
  };
  const filterSearch = text => filterChange('text', text);
  const filterSearchClear = () => filterChange('text', '');
  const filterClear = () => jobActions.serverFilter(job.initialIndexQuery.filters, job.initialIndexQuery);
  const displayOrgFilter = jobFormFilters.length
  // check the jobFormFilters for Organization - and if display is true
  ? jobFormFilters.some(ft => ft.title === 'Organization' && ft.display)
  // if setttings are still loading, we don't want to display org filters - defaults to true
  : !loadingSettings;
  const rows = job.list.map((jobRow, index) => /*#__PURE__*/React.createElement(JobsRow, {
    index: index,
    key: "JOB_".concat(jobRow.id, "_").concat(jobRow.jobNumber),
    data: jobRow,
    onClick: handleJobSelect,
    isSelected: _.contains(job.selected, jobRow.id),
    hasActions: canEdit
  }));
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(FormsFilterPanel, {
    closed: job.indexQuery.filters.closed,
    filters: job.indexQuery.filters,
    indexQuery: job.indexQuery,
    onFilter: filterChange,
    onFilterClear: filterClear,
    onSearch: filterSearch,
    onSearchClear: filterSearchClear,
    organizations: organizationFilterJob.list || [],
    selectedOrganizations: job.indexQuery.filters.organizations || [],
    formTypeIdentifier: "job"
  }, /*#__PURE__*/React.createElement(JobOpenClosedFilter, {
    onFilter: filterChange,
    closed: job.indexQuery.filters.closed
  }), displayOrgFilter && /*#__PURE__*/React.createElement(JobOrganizationFilter, {
    selectedOrganizations: job.indexQuery.filters.organizations || [],
    organizations: organizationFilterJob.list || [],
    onFilter: filterChange
  }))), /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, /*#__PURE__*/React.createElement(ListPanel, {
    title: "Jobs",
    showNew: canEdit,
    onAdd: handleAddJob
  }, /*#__PURE__*/React.createElement(JobsPagingTable, {
    headers: ['Job Number', 'Name'],
    loading: job.loading,
    indexQuery: job.indexQuery,
    hideSortOptions: true
  }, rows)))));
};
Jobs.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  canView: PropTypes.bool.isRequired,
  country: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  }).isRequired,
  countryActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  currentFormType: PropTypes.shape({
    id: PropTypes.string
  }),
  formActions: PropTypes.shape({
    create: PropTypes.func
  }).isRequired,
  formType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  }).isRequired,
  formTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  formForm: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  }).isRequired,
  formFormActions: PropTypes.shape({
    serverFilter: PropTypes.func,
    serverIndex: PropTypes.func
  }).isRequired,
  job: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string
    })),
    loading: PropTypes.bool,
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({
        closed: PropTypes.string,
        organizations: PropTypes.arrayOf(PropTypes.shape({}))
      })
    }).isRequired,
    initialIndexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    }),
    selected: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  jobActions: PropTypes.shape({
    serverIndex: PropTypes.func,
    serverFilter: PropTypes.func,
    create: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
  login: PropTypes.shape({
    user: PropTypes.shape({
      user_id: PropTypes.string
    }),
    geolocation: PropTypes.shape({
      country_name: PropTypes.string,
      region_name: PropTypes.string,
      time_zone: PropTypes.string
    })
  }).isRequired,
  organizationFilterJobActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  organizationFilterJob: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  }).isRequired,
  state: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  }).isRequired,
  stateActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  settings: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    settings: PropTypes.shape({})
  }).isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func
  }).isRequired
};
export { Jobs as TestJobs };
export default entityComposition(Jobs, ['job', 'form', 'formType', 'state', 'country', 'login', 'organizationFilterJob', 'settings', 'formForm'], {
  // assuming single job type for now
  currentFormType: state => state.formType.list.find(ft => ft.identifier === 'job'),
  canView: state => viewPermissionSelector('job')(state),
  canEdit: state => editPermissionSelector('job')(state)
}, ['notification']);